import { EmptyCartWidgetStyled } from 'components/Pages/Cart/EmptyCartWidget/EmptyCartWidget.style';
import useTranslation from 'next-translate/useTranslation';
import { UnamusedFaceEmojiIcon } from 'public/svg/IconsSvg';

export const EmptyCartWidget: FC = () => {
    const { t } = useTranslation();

    return (
        <EmptyCartWidgetStyled>
            <UnamusedFaceEmojiIcon className="h-24 w-24 text-grayDarker" />
            <p>{t('Your cart is empty')}</p>
        </EmptyCartWidgetStyled>
    );
};
